import { post, get, put } from '@/utils/request';

export const MyPage = (data) => get('/order/run/my/page', data)
export const MyAudit = (data) => post('/order/run/my/audit', data)
export const MyEdit = (data) => put('/order/run/my/edit', data)
export const MyDetail = (id) => get(`/order/run/my/detail/${id}`)
export const MyDel = (data) => post(`/order/run/my/del`, data)
export const My = { list: MyPage, MyAudit, update: MyEdit, detail: MyDetail, deletes: MyDel }

export const TransitPage = (data) => get('/order/run/transit/page', data)
export const TransitArrive = data => put('/order/run/transit/confirm', data)
export const TransitEdit = (data) => put('/order/run/transit/edit', data)
export const TransitDetail = (id) => get(`/order/run/transit/detail/${id}`)
export const TransitDel = (data) => post(`/order/run/transit/del`, data)
export const SetRemark = (data) => post(`/order/run/transit/set/remark`, data)
export const Transit = { list: TransitPage, arrive: TransitArrive, update: TransitEdit, detail: TransitDetail, deletes: TransitDel, SetRemark }

export const arrivePage = data => get('/order/run/arrive/page', data)
export const arriveAudit = data => post('/order/run/arrive/audit', data)
export const arriveReply = data => post('/order/run/arrive/reply', data)
export const arriveEdit = (data) => put('/order/run/arrive/edit', data)
export const arriveDetail = (id) => get(`/order/run/arrive/detail/${ id }`, null)
export const arriveDel = (data) => post(`/order/run/transit/del`, data)
export const arriveExport = data => post('/order/run/arrive/export', data)
export const ArriveSetRemark = (data) => post(`/order/run/arrive/set/remark`, data)
export const Arrive = { list: arrivePage, arriveAudit, arriveReply, update: arriveEdit, detail: arriveDetail, deletes: arriveDel, exportApi: arriveExport }

export const cancelPage = data => get('/order/run/cancel/page', data)
export const cancelDeletes = ids => post('/order/run/cancel/del', ids)
export const cancelAudit = ids => put('/order/run/cancel/audit', ids)
export const canceltDetail = (id) => get(`/order/run/cancel/detail/${id}`)
export const CancelSetRemark = (data) => post(`/order/run/cancel/set/remark`, data)
export const Cancel = { list: cancelPage, deletes: cancelDeletes, cancelAudit, detail: canceltDetail, CancelSetRemark }

export const timeoutPage = data => get('/order/run/timeout/page', data)
export const timeoutDeletes = data => post('/order/run/timeout/del', data)
export const Timeout = { list: timeoutPage, deletes: timeoutDeletes }

export const transitEditAll = (data) => put(`/order/run/transit/edit/all`, data)
export const arriveEditAll = (data) => put(`/order/run/arrive/edit/all`, data)



